// extracted by mini-css-extract-plugin
export default {"page":"SettingsPageLayout_page__ele3C"};